<script>
import widgetMethod from '@src/mixins/widgetMethod.js'
export default {
  mounted() {
    if (this.$route.meta.authRequired || this.$route.name === 'login') {
      this.displayWidget()
    }
  },
  methods: {
    ...widgetMethod,
  },
}
</script>
<template>
  <div :class="$style.container">
    <b-img
      center
      src="@assets/images/xactus_logo.png"
      fluid-grow
      class="w-auto mt-5 mb-2"
    />
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  // max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
